import { Icon } from '@chakra-ui/react'

type Props = {
    fill?: string
}

export const IconCalendar = ({ fill }: Props): JSX.Element => {
    return (
        <Icon viewBox={`0 0 16 16`} w={`16px`} h={`16px`} fill="none">
            <path
                d="M4.5 0C4.775 0 5 0.223875 5 0.5V2H11V0.5C11 0.223875 11.225 0 11.5 0C11.775 0 12 0.223875 12 0.5V2H13C14.1031 2 15 2.89531 15 4V14C15 15.1031 14.1031 16 13 16H3C1.89531 16 1 15.1031 1 14V4C1 2.89531 1.89531 2 3 2H4V0.5C4 0.223875 4.225 0 4.5 0ZM14 6H2V14C2 14.5531 2.44781 15 3 15H13C13.5531 15 14 14.5531 14 14V6ZM13 3H3C2.44781 3 2 3.44688 2 4V5H14V4C14 3.44688 13.5531 3 13 3Z"
                fill={fill ? fill : '#828282'}
            />
        </Icon>
    )
}
